module.exports = __webpack_public_path__ + "assets/xmcyber_com_half.ae29483b.svg";